<template>
    <div class ="lLoading1" :style="{display:Display }">
      <img src='./loader.svg' />
    </div>
</template>
<style src="./lLoading1.css">
</style>
<script src="./lLoading1.js">
</script>
